(() => {
  const cfg = window.zmRfq || {};
  const KEY = 'zm-quote-v1';
  const PENDING = 'zm-quote-pending';
  const quoteUrl = cfg.quoteUrl || '/cart?view=quote';
  const money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });

  const store = {
    get(k, fallback, s = localStorage) {
      try { return JSON.parse(s.getItem(k)) || fallback; } catch (e) { return fallback; }
    },
    set(k, v, s = localStorage) {
      try { s.setItem(k, JSON.stringify(v)); } catch (e) { }
    },
    del(k, s = localStorage) {
      try { s.removeItem(k); } catch (e) { }
    }
  };

  const items = () => store.get(KEY, []);
  const save = (list) => { store.set(KEY, list); updateHeader(); };
  const count = () => items().reduce((n, i) => n + (i.qty || 0), 0);

  function updateHeader() {
    const n = count();
    document.querySelectorAll('[data-rfq-header]').forEach((el) => {
      el.style.display = n > 0 ? '' : 'none';
      const c = el.querySelector('[data-rfq-count]');
      if (c) c.textContent = n;
    });
  }

  function add(item) {
    const list = items();
    const hit = list.find((i) => i.variant_id === item.variant_id);
    if (hit) hit.qty += item.qty;
    else list.push(item);
    save(list);
  }

  const lastVariant = {};
  document.addEventListener('on:variant:change', (e) => {
    const d = e.detail || {};
    if (d.product && d.variant) lastVariant[d.product.id] = d.variant.id;
  });

  function initAddButtons() {
    document.querySelectorAll('[data-rfq-add]').forEach((wrap) => {
      if (wrap.dataset.rfqReady) return;
      wrap.dataset.rfqReady = '1';
      let product;
      try { product = JSON.parse(wrap.querySelector('[data-rfq-product]').textContent); } catch (e) { return; }
      const btn = wrap.querySelector('[data-rfq-add-btn]');
      const qtyEl = wrap.querySelector('[data-rfq-qty]');
      const msg = wrap.querySelector('[data-rfq-msg]');
      btn.addEventListener('click', () => {
        const form = document.getElementById(wrap.dataset.formId);
        const idInput = form && form.querySelector('input[name="id"]');
        const urlVid = Number(new URLSearchParams(window.location.search).get('variant'));
        const vid = Number(idInput && idInput.value) || lastVariant[product.id] || urlVid || product.variants[0].id;
        const v = product.variants.find((x) => x.id === vid) || product.variants[0];
        const qty = Math.max(1, parseInt(qtyEl.value, 10) || 1);
        add({
          variant_id: v.id,
          product_id: product.id,
          handle: product.handle,
          title: product.title,
          variant: variantLabel(product, v),
          sku: v.sku || '',
          price: v.price,
          vendor: product.vendor || '',
          image: v.image || product.image || '',
          url: `${product.url}?variant=${v.id}`,
          qty
        });
        msg.hidden = false;
        qtyEl.value = 1;
      });
    });
  }

  function variantLabel(product, v) {
    if (v.title === 'Default Title') return '';
    const names = product.options || [];
    const vals = v.options || [];
    if (names.length && names.length === vals.length) return names.map((n, i) => `${n}: ${vals[i]}`).join(', ');
    return v.title;
  }

  function makeRef() {
    const d = new Date();
    const p = (n) => String(n).padStart(2, '0');
    const rand = Math.floor(1000 + Math.random() * 9000);
    return `Q${String(d.getFullYear()).slice(2)}${p(d.getMonth() + 1)}${p(d.getDate())}-${rand}`;
  }

  function renderList(page) {
    const list = items();
    const box = page.querySelector('[data-rfq-list]');
    const empty = page.querySelector('[data-rfq-empty]');
    const form = page.querySelector('#rfq-form');
    empty.hidden = list.length > 0;
    form.hidden = list.length === 0;
    box.hidden = list.length === 0;
    box.innerHTML = '';
    if (!list.length) return;

    const table = document.createElement('div');
    table.className = 'rfq-table';
    list.forEach((it, idx) => {
      const row = document.createElement('div');
      row.className = 'rfq-row';
      const img = it.image ? `<img src="${it.image}" alt="" width="64" height="64" loading="lazy">` : '';
      row.innerHTML = `
        <div class="rfq-row__img">${img}</div>
        <div class="rfq-row__info">
          <a class="rfq-row__title" href="${it.url}"></a>
          <div class="rfq-row__meta text-sm"></div>
        </div>
        <div class="rfq-row__qty">
          <label class="visually-hidden" for="rfq-row-qty-${idx}">Quantity</label>
          <input class="rfq-add__qty" id="rfq-row-qty-${idx}" type="number" min="1" step="1" value="${it.qty}" inputmode="numeric">
        </div>
        <button type="button" class="rfq-row__remove link text-sm">Remove</button>`;
      row.querySelector('.rfq-row__title').textContent = it.title;
      row.querySelector('.rfq-row__meta').textContent = [it.variant, it.sku ? `SKU: ${it.sku}` : ''].filter(Boolean).join(' · ');
      row.querySelector('input').addEventListener('change', (e) => {
        const l = items();
        l[idx].qty = Math.max(1, parseInt(e.target.value, 10) || 1);
        e.target.value = l[idx].qty;
        save(l);
      });
      row.querySelector('.rfq-row__remove').addEventListener('click', () => {
        const l = items();
        l.splice(idx, 1);
        save(l);
        renderList(page);
      });
      table.appendChild(row);
    });
    box.appendChild(table);
  }

  function buildPayload(ref, list) {
    const origin = cfg.shop || window.location.origin;
    const lines = list.map((it) => {
      const name = it.variant ? `${it.title} - ${it.variant}` : it.title;
      const price = it.price > 0 ? `${money.format(it.price / 100)} ex GST each` : 'POA';
      return `${it.qty} x ${name} | SKU: ${it.sku || 'n/a'} | ${price} | ${origin}${it.url}`;
    });
    const total = list.reduce((n, it) => n + it.price * it.qty, 0);
    lines.push(`Total at list price: ${money.format(total / 100)} ex GST`);
    return { text: lines.join('\n') };
  }

  function shortImg(src) {
    if (!src) return '';
    return src.replace(/^(https?:)?\/\/zonemedical\.com\.au\/cdn\/shop\//, '').slice(0, 160);
  }

  function sendBeacon(ref, list, form) {
    const val = (n, max) => ((form.querySelector(`[name="${n}"]`) || {}).value || '').trim().slice(0, max);
    const data = {
      ref,
      fn: val('contact[First name]', 60),
      ln: val('contact[Last name]', 60),
      em: val('contact[email]', 120),
      ph: val('contact[Phone]', 30),
      co: val('contact[Company]', 100),
      ad: val('contact[Delivery address]', 120),
      it: list.slice(0, 40).map((i) => [i.sku || '', i.qty, i.price, i.title.slice(0, 70), (i.variant || '').slice(0, 60), shortImg(i.image), (i.vendor || '').slice(0, 30)])
    };
    const base = `${cfg.webhook}&payload=`;
    const url = (d) => base + encodeURIComponent(JSON.stringify(d));
    let msg = val('contact[body]', 1500);
    data.msg = msg;
    if (url(data).length > 3600) data.it = data.it.map((r) => r.slice(0, 5));
    while (url(data).length > 3600 && msg.length > 0) {
      msg = msg.slice(0, Math.max(0, msg.length - 200));
      data.msg = msg ? `${msg}... (full message in the website email)` : '(see website email)';
    }
    if (url(data).length > 3600) data.it = data.it.map((r) => [r[0], r[1], r[2], '', '']);
    const img = new Image();
    img.src = url(data);
  }

  function initPage() {
    const page = document.querySelector('[data-rfq-page]');
    const params = new URLSearchParams(window.location.search);
    const pending = store.get(PENDING, null, sessionStorage);
    const fresh = pending && Date.now() - pending.at < 30 * 60 * 1000;
    const posted = params.get('contact_posted') === 'true' || params.get('quote_sent') === '1';

    if (!page) {
      if (posted && fresh) window.location.replace(`${quoteUrl}&quote_sent=1`);
      return;
    }

    if ((page.querySelector('[data-rfq-posted]') || posted) && fresh) {
      store.del(KEY);
      store.del(PENDING, sessionStorage);
      updateHeader();
      page.querySelector('[data-rfq-body]').hidden = true;
      const thanks = page.querySelector('[data-rfq-thanks]');
      thanks.querySelector('[data-rfq-thanks-ref]').textContent = pending.ref;
      thanks.hidden = false;
      return;
    }

    renderList(page);
    const form = page.querySelector('#rfq-form');
    const err = page.querySelector('[data-rfq-error]');
    form.addEventListener('submit', (e) => {
      const list = items();
      if (!list.length) {
        e.preventDefault();
        err.textContent = 'Your quote is empty. Add a product first.';
        err.hidden = false;
        return;
      }
      if (form.dataset.rfqRef) return;
      const ref = makeRef();
      form.dataset.rfqRef = ref;
      const payload = buildPayload(ref, list);
      form.querySelector('[data-rfq-ref]').value = ref;
      form.querySelector('[data-rfq-items]').value = payload.text;
      store.set(PENDING, { ref, at: Date.now() }, sessionStorage);
      const hp = form.querySelector('[data-rfq-hp]');
      if (cfg.webhook && !(hp && hp.value)) sendBeacon(ref, list, form);
      form.querySelector('[data-rfq-submit]').textContent = 'Submitting...';
    });
  }

  const ids = new Set((cfg.ids || []).map(String));
  const SNIZE_ITEM = '.snize-product, .snize-ac-product, li[id^="snize-product-"], li[id^="snize-ac-product-"]';

  function snizeId(el) {
    const m = (el.id || '').match(/(\d{6,})/);
    return el.dataset.originalProductId || (m && m[1]) || '';
  }

  function snizeIsQuote(el) {
    if (ids.has(snizeId(el))) return true;
    if (!cfg.zero) return false;
    const price = el.querySelector('.snize-price, .snize-price-list');
    return !!price && /\$\s?0(\.00)?(?!\d)/.test(price.textContent) && !/[1-9]/.test(price.textContent);
  }

  function scanSnize() {
    document.querySelectorAll(SNIZE_ITEM).forEach((el) => {
      if (el.dataset.rfqChecked) return;
      el.dataset.rfqChecked = '1';
      if (!snizeIsQuote(el)) return;
      el.classList.add('rfq-snize');
      const price = el.querySelector('.snize-price-list, .snize-price');
      if (price && !el.querySelector('.rfq-price__text')) {
        const note = document.createElement('span');
        note.className = 'rfq-price__text';
        note.textContent = cfg.priceText || 'Price on request';
        price.insertAdjacentElement('afterend', note);
      }
    });
  }

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scanSnize(); initAddButtons(); });
  });

  function init() {
    updateHeader();
    initAddButtons();
    initPage();
    scanSnize();
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', (e) => { if (e.key === KEY) updateHeader(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
